// extracted by mini-css-extract-plugin
module.exports = {"root":"BackButton_root__lznBN","before":"BackButton_before__RoD_t","arrow":"BackButton_arrow__JquWW","content":"BackButton_content__8HX2x"};